export default __webpack_public_path__ + "static/media/pack4c.1681c960.png";